import React, { useState } from "react";
import { Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import BreadcrumbSection from "../../../components/BreadcrumbSection";
import FilterComponent from "../../../components/FilterComponent";
import { Icon } from "@iconify/react";
import ClientSideCategoriesComponent from "../../../components/ClientSideCategoriesComponent";
// Sort Dropdown Component
const SortDropdown = () => {
  const [filters, setFilters] = useState({
    ratings: true,
    pricing: false,
    reviews: false,
  });

  const [sortOptions, setSortOptions] = useState({
    ratings: "",
    pricing: "",
    reviews: "",
  });

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [id]: checked,
    }));
  };

  const handleRadioChange = (category, value) => {
    setSortOptions((prevOptions) => ({
      ...prevOptions,
      [category]: value,
    }));
  };
  return (
    <Dropdown className="sortDropdown" align="end">
      <Dropdown.Toggle
        variant="light"
        className="d-flex align-items-center rounded-pill px-3"
      >
        <Icon icon="solar:sort-linear" fontSize={19} className="me-2" />
        <span className="iconFull">Sort By</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div>
          {/* Ratings */}
          <Form.Check
            type="checkbox"
            id="ratings"
            checked={filters.ratings}
            onChange={handleCheckboxChange}
            label={<strong>Ratings</strong>}
            className="mb-3"
          />

          {filters.ratings && (
            <div className="radiobox mb-4">
              <Form>
                <Form.Group className="mb-2 d-flex justify-content-between align-items-center">
                  <Form.Label className="mb-0">High to Low</Form.Label>
                  <Form.Check
                    type="radio"
                    id="ratings-high-to-low"
                    name="ratings"
                    checked={sortOptions.ratings === "high-to-low"}
                    onChange={() => handleRadioChange("ratings", "high-to-low")}
                    style={{
                      accentColor:
                        sortOptions.ratings === "high-to-low" ? "red" : "gray",
                    }}
                  />
                </Form.Group>

                <Form.Group className="d-flex justify-content-between align-items-center">
                  <Form.Label className="mb-0">Low to High</Form.Label>
                  <Form.Check
                    type="radio"
                    id="ratings-low-to-high"
                    name="ratings"
                    checked={sortOptions.ratings === "low-to-high"}
                    onChange={() => handleRadioChange("ratings", "low-to-high")}
                    style={{
                      accentColor:
                        sortOptions.ratings === "low-to-high" ? "red" : "gray",
                    }}
                  />
                </Form.Group>
              </Form>
            </div>
          )}

          {/* Pricing */}
          <Form.Check
            type="checkbox"
            id="pricing"
            checked={filters.pricing}
            onChange={handleCheckboxChange}
            label={<strong>Pricing</strong>}
            className="mb-3"
          />

          {filters.pricing && (
            <div className="radiobox mb-4">
              <Form>
                <Form.Group className="mb-2 d-flex justify-content-between align-items-center">
                  <Form.Label className="mb-0">High to Low</Form.Label>
                  <Form.Check
                    type="radio"
                    id="pricing-high-to-low"
                    name="pricing"
                    checked={sortOptions.pricing === "high-to-low"}
                    onChange={() => handleRadioChange("pricing", "high-to-low")}
                    style={{
                      accentColor:
                        sortOptions.pricing === "high-to-low" ? "red" : "gray",
                    }}
                  />
                </Form.Group>

                <Form.Group className="d-flex justify-content-between align-items-center">
                  <Form.Label className="mb-0">Low to High</Form.Label>
                  <Form.Check
                    type="radio"
                    id="pricing-low-to-high"
                    name="pricing"
                    checked={sortOptions.pricing === "low-to-high"}
                    onChange={() => handleRadioChange("pricing", "low-to-high")}
                    style={{
                      accentColor:
                        sortOptions.pricing === "low-to-high" ? "red" : "gray",
                    }}
                  />
                </Form.Group>
              </Form>
            </div>
          )}

          {/* Reviews */}
          <Form.Check
            type="checkbox"
            id="reviews"
            checked={filters.reviews}
            onChange={handleCheckboxChange}
            label={<strong>Number of Reviews</strong>}
          />

          {filters.reviews && (
            <div className="radiobox mt-3">
              <Form>
                <Form.Group className="mb-2 d-flex justify-content-between align-items-center">
                  <Form.Label className="mb-0">High to Low</Form.Label>
                  <Form.Check
                    type="radio"
                    id="reviews-high-to-low"
                    name="reviews"
                    checked={sortOptions.reviews === "high-to-low"}
                    onChange={() => handleRadioChange("reviews", "high-to-low")}
                    style={{
                      accentColor:
                        sortOptions.reviews === "high-to-low" ? "red" : "gray",
                    }}
                  />
                </Form.Group>

                <Form.Group className="d-flex justify-content-between align-items-center">
                  <Form.Label className="mb-0">Low to High</Form.Label>
                  <Form.Check
                    type="radio"
                    id="reviews-low-to-high"
                    name="reviews"
                    checked={sortOptions.reviews === "low-to-high"}
                    onChange={() => handleRadioChange("reviews", "low-to-high")}
                    style={{
                      accentColor:
                        sortOptions.reviews === "low-to-high" ? "red" : "gray",
                    }}
                  />
                </Form.Group>
              </Form>
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const ClientSideProtectionSolutions = () => {
  return (
    <React.Fragment>
      {/* BreadCrumb Section */}
      <BreadcrumbSection
        breadcrumbs={[
          {
            title: "Solutions",

            link: "/solutions",
          },
          { title: "Client-Side Protection" }, // Active breadcrumb (no link)
        ]}
      />
      <section className="software_section py-4 py-md-5">
        <Container>
          <Row className="mb-0">
            <Col lg={12}>
              <div className="software_header software_headerFlex">
                <h2 className="textCenter">
                  120 Listings in Client-Side Protection Available
                </h2>
                <div className="soft_dropdown">
                  <SortDropdown />
                  <FilterComponent />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <ClientSideCategoriesComponent />
    </React.Fragment>
  );
};
export default ClientSideProtectionSolutions;
